import { SupportedLanguages } from 'common/locale';

const buildUrl = (publicPaymentUrl: string, params: Record<string, string>) => {
  try {
    const url = new URL(publicPaymentUrl);
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });
    return url.toString();
  } catch {
    return publicPaymentUrl;
  }
};

export const buildPaymentLink = ({
  lang,
  publicPaymentUrl,
}: {
  lang: SupportedLanguages;
  publicPaymentUrl: string;
}) => {
  return buildUrl(publicPaymentUrl, {
    lang,
    utm_medium: 'copy-url-cta',
    utm_source: 'invoice-page',
  });
};
